import {
    MutableRefObject,
    useEffect, useRef,
} from 'react'
import {
    ExtendedGridApiPro,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'

export default function useAutoOpenForm(
    apiRef: MutableRefObject<ExtendedGridApiPro>,
    autoOpenForm: boolean,
) {
    const openedOnceRef = useRef(false)

    useEffect(() => {
        const api = apiRef.current

        if (!api) return

        const unsubscribe = api.subscribeEvent('rowsSet', () => {
            if (openedOnceRef.current) return
            if (!autoOpenForm) return

            const count = api.getRowsCount()

            if (count === 1) {
                api.setExpandedDetailPanels(new Set([api.getRowIdFromRowIndex(0)]))
                openedOnceRef.current = true
            }
        })

        // eslint-disable-next-line consistent-return
        return unsubscribe
    }, [
        apiRef,
        autoOpenForm,
    ])
}
